import React from 'react';

import { SidebarModalBlockComponent } from 'design/sidebarModal';
import { TextComponent } from 'design/text/textComponents';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { MarginComponent } from 'design/margin';
import {
  SmallTableRowComponent,
  SmallTableWrapperComponent,
} from 'design/smallTable';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { LinkControlComponent } from 'design/linkControl';
import { normalizeURL } from 'utils/noramlizeURL';
import { Client } from 'types/clientTypes';

type Props = {
  client: Client;
};

export const PartnerClientManagerSummary = (props: Props) => {
  const { client } = props;

  const {
    partnerClientManager: ownDictionary,
    shared: sharedDictionary,
  } = useIntlDictionary();

  return (
    <>
      <SidebarModalBlockComponent withBorder>
        <TextComponent size="mp" weight="medium">
          {ownDictionary.clientSummaryTable.title}
        </TextComponent>
        <MarginComponent top={20} />
        <SmallTableWrapperComponent>
          <SmallTableRowComponent>
            <TextComponent>
              {ownDictionary.clientSummaryTable.contactLabel}
            </TextComponent>
            <TextComponent>
              {normalizeProfileLike(client.person).toFullName()}
            </TextComponent>
          </SmallTableRowComponent>
          <SmallTableRowComponent>
            <TextComponent>
              {ownDictionary.clientSummaryTable.positionLabel}
            </TextComponent>
            <TextComponent>{client.position}</TextComponent>
          </SmallTableRowComponent>
          <SmallTableRowComponent>
            <TextComponent>
              {ownDictionary.clientSummaryTable.phoneLabel}
            </TextComponent>
            <TextComponent>{client.person.phone}</TextComponent>
          </SmallTableRowComponent>
          <SmallTableRowComponent>
            <TextComponent>
              {ownDictionary.clientSummaryTable.sizeLabel}
            </TextComponent>
            <TextComponent>
              {client.org.staffCount
                ? sharedDictionary.orgStaffCount(client.org.staffCount)
                : '-'}
            </TextComponent>
          </SmallTableRowComponent>
        </SmallTableWrapperComponent>
      </SidebarModalBlockComponent>
      {client.prodStackInfo && (
        <SidebarModalBlockComponent withBorder>
          <TextComponent size="mp" weight="medium">
            {ownDictionary.stackSummaryTable.title}
          </TextComponent>
          <MarginComponent top={20} />
          <SmallTableWrapperComponent>
            {client.prodStackInfo.originURL && (
              <SmallTableRowComponent>
                <TextComponent>
                  {ownDictionary.stackSummaryTable.hostNameLabel}
                </TextComponent>
                <LinkControlComponent to={client.prodStackInfo.originURL}>
                  <TextComponent color="accent" animatedColor>
                    {normalizeURL(client.prodStackInfo.originURL).toHostName()}
                  </TextComponent>
                </LinkControlComponent>
              </SmallTableRowComponent>
            )}
            {client.prodStackInfo.licensesCount !== null && (
              <SmallTableRowComponent>
                <TextComponent>
                  {ownDictionary.stackSummaryTable.managersCountLabel}
                </TextComponent>
                <TextComponent>
                  {client.prodStackInfo.licensesCount}
                </TextComponent>
              </SmallTableRowComponent>
            )}
          </SmallTableWrapperComponent>
        </SidebarModalBlockComponent>
      )}
    </>
  );
};
